<template>
  <section class="bm-title">
    <header class="bm-title__head">
      <div class="bm-title__crumb">
        <button @click="$emit('back')">‹ 返回</button>
        <span>
          云库工作台　›　批量修改　›　
          <strong>导购短标题</strong>
        </span>
        <a>帮助教程</a>
      </div>
      <h1>批量修改导购短标题</h1>
      <nav>
        <button class="mode-range" :class="{ active: mode === 'range' }" @click="switchMode('range')">
          按范围修改
        </button>
        <button class="mode-goods" :class="{ active: mode === 'goods' }" @click="switchMode('goods')">
          按商品修改
        </button>
      </nav>
    </header>
    <main class="bm-title__body">
      <section v-if="mode === 'range'" class="bm-title__filter">
        <div v-for="field in fields" :key="field.key" class="bm-title__field">
          <label>{{ field.label }}</label>
          <el-select
            v-if="field.select || field.key === 'group_id' || field.key === 'child_group_id'"
            v-model="filterValues[field.key]"
            @change="field.key === 'group_id' && onGroupChange()"
            class="bm-title__filter-select">
            <el-option :label="field.placeholder" :value="''" />
            <el-option
              v-for="option in optionsFor(field.key)"
              :key="option.value"
              :label="option.label"
              :value="option.value" />
          </el-select>
          <div v-else-if="field.range" class="bm-title__date-range">
            <input v-model="addTime[0]" class="bm-title__date-input" type="date" aria-label="开始时间" />
            <span class="bm-title__date-separator">—</span>
            <input v-model="addTime[1]" class="bm-title__date-input" type="date" aria-label="结束时间" />
          </div>
          <input v-else :placeholder="field.placeholder" v-model="filterValues[field.key]" />
        </div>
        <footer>
          <!-- <button class="more-search" @click="moreSearch = true">更多搜索 ▾</button> -->
          <div class="bm-short-title__search-actions">
            <button @click="loadPreview()">查询</button>
            <button class="plain" @click="resetFilters">重置</button>
          </div>
        </footer>
      </section>
      <section v-else class="bm-title__picked">
        <button @click="openSelector">选择商品</button>
        <span>{{ selected.length ? '已选择 ' + selected.length + ' 个商品' : '请先选择需要修改的商品' }}</span>
      </section>
      <section class="bm-title__methods bm-short-title__strategy">
        <header>
          <i></i>
          修改策略
        </header>
        <div class="bm-short-title__strategy-body">
          <label>
            <el-checkbox v-model="conditions.skip_existing" :disabled="hasClearMethod || hasAdvancedMethod">
              若商品已有导购短标题，则不进行修改
            </el-checkbox>
          </label>
        </div>
      </section>
      <section class="bm-title__methods">
        <header>
          <i></i>
          修改内容
        </header>
        <article v-for="method in methods" :key="method.type">
          <el-checkbox
            v-model="method.on"
            :disabled="isMethodDisabled(method)"
            @change="handleMethodChange(method, $event)"
            class="bm-title__method-name">
            方式{{ method.order }}：{{ method.name }}
          </el-checkbox>
          <div v-if="method.on" class="bm-title__method-content">
            <template v-if="method.type === 401">
              <div class="bm-title__count-input">
                <input
                  v-model="form.value"
                  class="long"
                  maxlength="24"
                  placeholder="短标题字数要求：4-12个汉字（即8-24字符）" />
                <small>{{ form.value.length }}/24</small>
              </div>
            </template>
            <template v-else-if="method.type === 402">
              使用标题
              <el-input-number
                v-model="form.length"
                class="bm-short-title__length-input"
                :min="4"
                :max="12"
                controls-position="right" />
              <span>个字</span>
              <span class="bm-short-title__from-title-options">
                <el-checkbox
                  :value="form.fromTitleDirection === 'tail'"
                  @change="setFromTitleDirection('tail', $event)">
                  删除标题后面的文字
                </el-checkbox>
                <el-checkbox
                  :value="form.fromTitleDirection === 'head'"
                  @change="setFromTitleDirection('head', $event)">
                  删除标题前面的文字
                </el-checkbox>
              </span>
            </template>
            <template v-else-if="method.type === 403">
              <span>将导购短标题清空</span>
            </template>
            <template v-else-if="method.type === 104">
              <div class="bm-title__count-textarea">
                <textarea
                  v-model="form.keywords"
                  maxlength="10000"
                  placeholder="多个关键词用逗号分隔，最多10000字"></textarea>
                <small>{{ form.keywords.length }}/10000</small>
              </div>
            </template>
            <template v-else-if="method.type === 105">
              <el-checkbox
                v-for="option in filterOptions"
                :key="option.value"
                v-model="form.filters"
                :label="option.value">
                {{ option.label }}
              </el-checkbox>
            </template>
            <template v-else-if="method.type === 107">
              <div v-for="(replace, replaceIndex) in form.replaces" :key="replaceIndex" class="bm-title__replace">
                <input v-model="replace.find" placeholder="查找内容" />
                <span>→</span>
                <input v-model="replace.value" placeholder="替换为" />
                <button @click="addReplace">＋ 添加</button>
                <button v-if="replaceIndex" class="danger" @click="removeReplace(replaceIndex)">删除</button>
              </div>
            </template>
            <template v-else-if="method.type === 108">
              <div class="bm-title__inline">
                <span>前缀</span>
                <input v-model="form.prefix" placeholder="前缀内容" />
                <span>后缀</span>
                <input v-model="form.suffix" placeholder="后缀内容" />
              </div>
            </template>
            <template v-else>
              <span>替换前内容</span>
              <input v-model="form.before" placeholder="原前缀" />
              <span>替换后内容</span>
              <input v-model="form.after" placeholder="新前缀" />
              <small class="warning">将替换相应的字数，无需替换则为空</small>
            </template>
          </div>
        </article>
      </section>
      <section v-if="preview" class="bm-title__preview">
        <header>
          已选择
          <b>{{ mode === 'goods' ? selected.length : previewPage.total }}</b>
          个商品，当前预览
          <b>{{ previewPage.total }}</b>
          个，已排除 {{ excludedProductIds.length }} 个（当前页 {{ previewGoods.length }}）
          <button @click="preview = false">收起预览</button>
        </header>
        <table>
          <thead>
            <tr>
              <th>商品信息</th>
              <th>调整后短标题</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(good, n) in previewGoods"
              :key="good.id || n"
              :class="{
                'is-excluded': excludedProductIds.includes(Number(good.id))
              }">
              <td>
                <el-image
                  class="bm-title__image"
                  :src="imageOf(good)"
                  fit="cover"
                  :preview-src-list="[imageOf(good)]"
                  alt="商品主图" />
                <div>
                  <small class="bm-short-title__meta">
                    商品ID：{{ good.id }}　来源ID：{{ good.source_product_id || '—' }}　数据源：{{
                      sourceLabel(good.source_web)
                    }}
                  </small>
                  <small class="bm-short-title__text">标题：{{ good.title || good.old_title || '—' }}</small>
                  <small class="bm-short-title__text">短标题：{{ good.short_title || '—' }}</small>
                </div>
              </td>
              <td class="title-cell">
                <textarea v-model="good.new_short_title" readonly></textarea>
              </td>
              <td class="action-cell">
                <button
                  :class="{
                    restore: excludedProductIds.includes(Number(good.id))
                  }"
                  @click="toggleExclude(good)">
                  {{ excludedProductIds.includes(Number(good.id)) ? '恢复修改' : '排除修改' }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <footer class="bm-title__pagination">
          <button :disabled="previewPage.page <= 1" @click="loadPreview(previewPage.page - 1)">上一页</button>
          <span>第 {{ previewPage.page }} / {{ pageCount }} 页</span>
          <button :disabled="previewPage.page >= pageCount" @click="loadPreview(previewPage.page + 1)">下一页</button>
          <select v-model.number="previewPage.limit" @change="loadPreview(1)">
            <option :value="10">10条/页</option>
            <option :value="20">20条/页</option>
            <option :value="50">50条/页</option>
          </select>
        </footer>
      </section>
    </main>
    <footer class="bm-title__bottom">
      <button class="preview" @click="loadPreview()">修改内容预览</button>
      <button class="start" :disabled="loading" @click="startBatch">开始批量修改</button>
      <!-- <label><input v-model="scheduled" type="checkbox" /> 定时执行</label> -->
      <button v-if="scheduled" class="time" @click="schedule = true">
        {{ scheduleText }}
      </button>
    </footer>
    <div v-if="moreSearch" class="bm-title__mask">
      <div class="bm-title__more-modal">
        <header>
          <strong>支持更多搜索</strong>
          <button @click="moreSearch = false">×</button>
        </header>
        <main>
          <el-checkbox-group v-model="moreSearchChecked">
            <el-checkbox v-for="field in moreSearchFields" :key="field" :label="field">{{ field }}</el-checkbox>
          </el-checkbox-group>
        </main>
        <footer>
          <button class="plain" @click="resetMoreSearch">重置默认</button>
          <button class="plain" @click="moreSearch = false">取消</button>
          <button @click="moreSearch = false">应用</button>
        </footer>
      </div>
    </div>
    <div v-if="selecting" class="bm-title__mask">
      <div class="bm-title__select-modal">
        <header>
          <strong>选择修改商品</strong>
          <button @click="cancelSelection">×</button>
        </header>
        <nav>
          <button :class="{ active: selectorTab === 'all' }" @click="switchSelectorTab('all')">选择商品</button>
          <button :class="{ active: selectorTab === 'selected' }" @click="switchSelectorTab('selected')">已选择</button>
        </nav>
        <div class="bm-title__selector-toolbar">
          <div class="bm-title__select-filter">
            <el-select
              v-model="selectorFilters.group_id"
              popper-class="bm-title__select-popper"
              class="bm-title__group-select"
              placeholder="分组"
              @change="loadSelectorGroups">
              <el-option label="全部分组" value="" />
              <el-option v-for="group in groupList" :key="group.id" :label="group.name" :value="group.id" />
            </el-select>
            <el-select
              v-model="selectorFilters.child_group_id"
              popper-class="bm-title__select-popper"
              class="bm-title__group-select"
              placeholder="子分组"
              @change="loadGoods(1)">
              <el-option label="全部子分组" value="" />
              <el-option v-for="group in selectorChildGroups" :key="group.id" :label="group.name" :value="group.id" />
            </el-select>
            <input v-model="selectorFilters.source_product_id" placeholder="来源ID" />
            <input v-model="selectorFilters.keyword" placeholder="商品标题" />
            <button @click="loadGoods(1)">查询</button>
          </div>
          <div class="bm-title__selector-pagination">
            <button :disabled="selectorPage.page <= 1" @click="loadGoods(selectorPage.page - 1)">上一页</button>
            <span>{{ selectorPage.page }} / {{ Math.max(1, Math.ceil(selectorPage.total / selectorPage.limit)) }}</span>
            <button
              :disabled="selectorPage.page >= Math.max(1, Math.ceil(selectorPage.total / selectorPage.limit))"
              @click="loadGoods(selectorPage.page + 1)">
              下一页
            </button>
            <el-select
              v-model="selectorPage.limit"
              popper-class="bm-title__select-popper"
              class="bm-title__page-size"
              @change="loadGoods(1)">
              <el-option v-for="size in [10, 20, 50]" :key="size" :label="size + '条/页'" :value="size" />
            </el-select>
          </div>
          <label class="bm-title__select-all">
            <el-checkbox :value="selectorPageAllSelected" @change="togglePageGoods" />
            <span>全选</span>
          </label>
        </div>
        <main>
          <button
            v-for="good in displayedGoods"
            :key="good.id"
            :class="{ selected: selected.includes(Number(good.id)) }"
            @click="toggleGood(good.id)">
            <el-checkbox :value="selected.includes(Number(good.id))" @click.native.stop @change="toggleGood(good.id)" />
            <img :src="imageOf(good)" alt="商品主图" />
            <span>{{ good.title || good.product_title }}</span>
            <small>{{ priceRange(good) }}</small>
          </button>
        </main>
        <footer>
          <span>已选 {{ selected.length }} 个商品</span>
          <button class="plain" @click="cancelSelection">取消</button>
          <button @click="selecting = false">确定</button>
        </footer>
      </div>
    </div>
    <div v-if="schedule" class="bm-title__mask">
      <div class="bm-title__small-modal">
        <header>
          <strong>定时执行</strong>
          <button @click="schedule = false">×</button>
        </header>
        <main>
          <label>
            执行时间
            <input v-model="scheduleText" type="datetime-local" />
          </label>
        </main>
        <footer>
          <button class="plain" @click="schedule = false">取消</button>
          <button @click="schedule = false">确定</button>
        </footer>
      </div>
    </div>
    <div v-if="success" class="bm-title__mask">
      <div class="bm-title__small-modal">
        <header>
          <strong>提示</strong>
          <button @click="success = false">×</button>
        </header>
        <main class="success-message">
          <b>✓</b>
          <p>批量修改任务创建成功</p>
          <small>任务将在后台处理，请在批量修改记录中查看进度。</small>
        </main>
        <footer><button @click="success = false">我知道了</button></footer>
      </div>
    </div>
  </section>
</template>

<script>
import { createCloudShortTitleBatch, previewCloudShortTitleBatch } from '@/api/main/cloudBatchEdit'
import { cloudProductGroups, cloudProductList } from '@/api/main/ucenter'

const RULE_TYPES = [401, 402, 403, 104, 105, 107, 108, 110]
const fields = [
  { key: 'group_id', label: '分组', placeholder: '请选择分组' },
  { key: 'child_group_id', label: '子分组', placeholder: '请选择子分组' },
  { key: 'created_range', label: '导入时间', range: true },
  { key: 'source_product_id', label: '来源ID', placeholder: '请输入来源ID' },
  {
    key: 'sku_status',
    label: 'SKU替换状态',
    select: true,
    placeholder: '全部'
  },
  {
    key: 'sku_mark_status',
    label: '商品标记状态',
    select: true,
    placeholder: '全部'
  },
  {
    key: 'ai_title_status',
    label: '标题替换状态',
    select: true,
    placeholder: '全部'
  },
  { key: 'source_web', label: '数据源', select: true, placeholder: '全部' }
]
const defaultFilterValues = {
  group_id: '',
  child_group_id: '',
  source_product_id: '',
  sku_status: '',
  sku_mark_status: '',
  ai_title_status: '',
  source_web: ''
}
export default {
  name: 'BatchModifyShortTitle',
  data() {
    return {
      mode: 'range',
      fields,
      addTime: [],
      groupList: [],
      childGroupList: [],
      groupLoading: false,
      statusOptions: {
        sku_status: [],
        sku_mark_status: [],
        ai_title_status: [],
        source_web: []
      },
      filterValues: { ...defaultFilterValues },
      moreSearch: false,
      moreSearchFields: fields.map((field) => field.label),
      moreSearchChecked: fields.map((field) => field.label),
      conditions: { skip_existing: false },
      preview: false,
      previewGoods: [],
      previewPage: { page: 1, limit: 20, total: 0 },
      excludedProductIds: [],
      selecting: false,
      selectorTab: 'all',
      selectorLoading: false,
      selectorPage: { page: 1, limit: 20, total: 0 },
      selectorFilters: { group_id: '', child_group_id: '', source_product_id: '', keyword: '' },
      selectorChildGroups: [],
      selectedGoods: [],
      success: false,
      loading: false,
      schedule: false,
      scheduled: false,
      scheduleText: '2026-07-15T10:30',
      selected: [],
      methods: [
        '统一设置',
        '使用标题生成',
        '清空导购短标题',
        '删除关键词',
        '过滤设置',
        '关键词替换',
        '增加前后缀',
        '替换前后缀'
      ].map((name, index) => ({ type: RULE_TYPES[index], order: index + 1, name, on: false })),
      form: {
        value: '',
        length: 12,
        fromTitleDirection: 'tail',
        keywords: '',
        filters: [],
        replaces: [{ find: '', value: '' }],
        prefix: '',
        suffix: '',
        before: '',
        after: ''
      },
      // 过滤规则编码：中文仅用于展示，提交值固定为数字。
      filterOptions: [
        { label: '去除英文', value: 301 },
        { label: '去除数字', value: 302 },
        { label: '去除全部空格', value: 303 },
        { label: '仅去除首尾空格', value: 304 },
        { label: '去除英文符号', value: 305 },
        // { label: '去除货号', value: 306 },
        { label: '去除括号及内容', value: 307 },
        { label: '去除逗号', value: 308 }
      ],
      goods: []
    }
  },
  computed: {
    displayedGoods() {
      if (this.selectorTab !== 'selected') return this.goods
      const start = (this.selectorPage.page - 1) * this.selectorPage.limit
      return this.selectedGoods.slice(start, start + this.selectorPage.limit)
    },
    selectorPageAllSelected() {
      const list = this.displayedGoods
      return list.length > 0 && list.every((good) => this.selected.includes(Number(good.id)))
    },
    pageCount() {
      const total = Number(this.previewPage.total)
      const limit = Number(this.previewPage.limit)
      return Number.isFinite(total) && Number.isFinite(limit) && limit > 0 ? Math.max(1, Math.ceil(total / limit)) : 1
    },
    hasClearMethod() {
      return this.methods.some((item) => item.type === 403 && item.on)
    },
    hasAdvancedMethod() {
      return this.methods.some((item) => [104, 105, 107, 108, 110].includes(item.type) && item.on)
    }
  },
  created() {
    this.loadGroups()
  },
  methods: {
    switchMode(mode) {
      if (this.mode === mode) return
      this.mode = mode
      this.preview = false
      this.previewGoods = []
      this.excludedProductIds = []
      this.previewPage = { ...this.previewPage, page: 1, total: 0 }
    },
    async openSelector() {
      this.selecting = true
      if (!this.groupList.length) await this.loadGroups()
      this.loadSelectorGroups()
    },
    switchSelectorTab(tab) {
      this.selectorTab = tab
      if (tab === 'selected') {
        this.selectorPage = { ...this.selectorPage, page: 1, total: this.selectedGoods.length }
        return
      }
      this.loadGoods(1)
    },
    loadSelectorGroups() {
      const group = this.groupList.find((item) => String(item.id) === String(this.selectorFilters.group_id))
      this.selectorChildGroups = ((group && group.child_groups) || []).map((item) => ({
        ...item,
        id: item.id ?? item.group_id ?? item.child_group_id,
        name: item.name ?? item.group_name ?? item.child_group_name
      }))
      this.selectorFilters.child_group_id = ''
      this.loadGoods(1)
    },
    async loadGoods(page = 1) {
      if (this.selectorTab === 'selected') {
        const maxPage = Math.max(1, Math.ceil(this.selectedGoods.length / this.selectorPage.limit))
        this.selectorPage = { ...this.selectorPage, page: Math.min(page, maxPage), total: this.selectedGoods.length }
        return
      }
      this.selectorLoading = true
      try {
        const params = { page, page_size: this.selectorPage.limit, status: 1, ...this.selectorFilters }
        const response = await cloudProductList(params)
        const root = response && response.data ? response.data : response
        this.goods = Array.isArray(root) ? root : root.list || root.data || []
        const total = root.total !== undefined ? Number(root.total) : this.goods.length
        this.selectorPage = { page, limit: this.selectorPage.limit, total }
      } catch (e) {
        this.$message.error('商品查询失败')
      } finally {
        this.selectorLoading = false
      }
    },
    togglePageGoods(checked) {
      const ids = this.displayedGoods.map((good) => Number(good.id)).filter(Boolean)
      this.selected = checked
        ? Array.from(new Set([...this.selected, ...ids]))
        : this.selected.filter((id) => !ids.includes(id))
      if (checked) {
        ids.forEach((id) => {
          const good = this.displayedGoods.find((item) => Number(item.id) === id)
          if (good && !this.selectedGoods.some((item) => Number(item.id) === id)) this.selectedGoods.push(good)
        })
      } else {
        this.selectedGoods = this.selectedGoods.filter((item) => !ids.includes(Number(item.id)))
      }
      if (this.selectorTab === 'selected')
        this.selectorPage = { ...this.selectorPage, total: this.selectedGoods.length }
    },
    cancelSelection() {
      this.selected = []
      this.selectedGoods = []
      this.selecting = false
    },
    priceRange(good) {
      const min = good.min_price ?? good.price_min ?? good.price
      const max = good.max_price ?? good.price_max ?? min
      return min === undefined || min === null ? '价格待定' : `¥${min}~¥${max}`
    },
    isMethodDisabled(method) {
      return !method.on && this.methods.some((item) => item.on)
    },
    handleMethodChange(method, checked) {
      if (checked) {
        this.methods.forEach((item) => {
          item.on = item === method
        })
        if (method.type === 403 || [104, 105, 107, 108, 110].includes(method.type)) {
          this.conditions.skip_existing = false
        }
      }
    },
    async loadGroups() {
      this.groupLoading = true
      try {
        const r = await cloudProductGroups({ with_count: 0 })
        const data = (r.data && (r.data.data || r.data)) || []
        this.groupList = (Array.isArray(data) ? data : []).map((group) => ({
          ...group,
          id: group.id ?? group.group_id,
          name: group.name ?? group.group_name,
          child_groups: group.child_groups || group.children || group.sub_groups || []
        }))
        this.statusOptions = {
          sku_status: [
            { label: '待替换', value: 1 },
            { label: '已替换', value: 2 },
            { label: '找不到', value: 3 }
          ],
          sku_mark_status: [
            { label: '未标记', value: 1 },
            { label: '已标记', value: 2 },
            { label: '找不到', value: 3 }
          ],
          ai_title_status: [
            { label: '待替换', value: 1 },
            { label: '已替换', value: 2 },
            { label: '异常', value: 9 }
          ],
          source_web: [
            { value: 9, label: '星好货' },
            { value: 3, label: 'TB' },
            { value: 4, label: 'PDD' },
            { value: 2, label: '1688' },
            { value: 5, label: 'DY' },
            { value: 6, label: 'WX' }
          ]
        }
      } catch (e) {
        this.$message.error('分组加载失败')
      } finally {
        this.groupLoading = false
      }
    },
    optionsFor(key) {
      if (key === 'group_id') return this.groupList.map((i) => ({ value: i.id, label: i.name }))
      if (key === 'child_group_id') return this.childGroupList.map((i) => ({ value: i.id, label: i.name }))
      return this.statusOptions[key] || []
    },
    onGroupChange() {
      this.filterValues.child_group_id = ''
      const group = this.groupList.find((i) => String(i.id) === String(this.filterValues.group_id))
      this.childGroupList = (group && (group.child_groups || group.children || [])) || []
    },
    resetFilters() {
      this.filterValues = { ...defaultFilterValues }
      this.addTime = []
      this.preview = false
      this.previewGoods = []
      this.excludedProductIds = []
      this.previewPage = { ...this.previewPage, page: 1, total: 0 }
    },
    setFromTitleDirection(direction, checked) {
      if (checked) this.form.fromTitleDirection = direction
    },
    buildQueryPayload() {
      const payload = { ...this.filterValues }
      delete payload.created_range
      if (this.addTime && this.addTime.length === 2) {
        payload.created_start = this.addTime[0]
        payload.created_end = this.addTime[1]
      } else {
        delete payload.created_start
        delete payload.created_end
      }
      return {
        ...payload,
        ...(this.mode === 'goods' ? { product_ids: this.selected } : {}),
        rules: this.methods.filter((m) => m.on).map((m) => ({ type: m.type, options: this.ruleOptions(m.type) })),
        conditions: this.conditions,
        excluded_product_ids: this.excludedProductIds
      }
    },
    ruleOptions(type) {
      const map = {
        401: ['value'],
        402: ['length'],
        104: ['keywords'],
        105: ['filters'],
        107: ['replaces'],
        108: ['prefix', 'suffix'],
        110: ['before', 'after']
      }
      const options = (map[type] || []).reduce((result, key) => ({ ...result, [key]: this.form[key] }), {})
      return type === 402 ? { ...options, direction: this.form.fromTitleDirection } : options
    },
    parsePageResponse(response) {
      const root =
        response && response.data && !Array.isArray(response.data) && (response.data.data || response.data.list)
          ? response.data
          : response
      const page =
        root && root.data && !Array.isArray(root.data) && (root.data.data || root.data.list) ? root.data : root
      const list = Array.isArray(page) ? page : (page && (page.data || page.list)) || []
      return {
        list,
        total: page && page.total !== undefined ? Number(page.total) : list.length,
        page: page && (page.current_page || page.currentPage) ? Number(page.current_page || page.currentPage) : null,
        limit: Number((page && (page.per_page || page.perPage)) || this.previewPage.limit)
      }
    },
    async loadPreview(page = 1) {
      if (this.loading) return
      if (this.mode === 'goods' && !this.selected.length) {
        this.$message.warning('请先选择商品')
        return
      }
      const requestedPage = Number(page)
      const target = Math.min(Math.max(1, Number.isFinite(requestedPage) ? requestedPage : 1), this.pageCount)
      this.loading = true
      try {
        const r = await previewCloudShortTitleBatch({
          ...this.buildQueryPayload(),
          page: target,
          limit: this.previewPage.limit
        })
        const result = this.parsePageResponse(r)
        this.previewGoods = result.list
        this.previewPage = {
          page: result.page || target,
          limit: result.limit || this.previewPage.limit,
          total: result.total
        }
        this.preview = true
      } catch (e) {
        this.$message.error(this.errorMessage(e, '查询失败'))
      } finally {
        this.loading = false
      }
    },
    async startBatch() {
      if (this.loading) return
      this.loading = true
      try {
        const response = await createCloudShortTitleBatch(this.buildQueryPayload())
        if (response && response.code !== undefined && Number(response.code) !== 200) {
          throw new Error(response.message || '创建任务失败')
        }
        this.success = true
        this.$emit('created')
      } catch (e) {
        this.$message.error(this.errorMessage(e, '创建任务失败'))
      } finally {
        this.loading = false
      }
    },
    imageOf(good) {
      return (
        good.main_image ||
        good.image_url ||
        (Array.isArray(good.main_images) ? good.main_images[0] : '') ||
        "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='52' height='52'%3E%3Crect width='100%' height='100%' fill='%23f5f5f5'/%3E%3Ctext x='50%' y='55%' text-anchor='middle' fill='%23999' font-size='10'%3E暂无图片%3C/text%3E%3C/svg%3E"
      )
    },
    errorMessage(error, fallback) {
      return error?.response?.data?.message || error?.response?.data?.msg || error?.message || fallback
    },
    imageError(e) {
      e.target.src = this.imageOf({})
    },
    sourceLabel(value) {
      const item = this.statusOptions.source_web.find((i) => String(i.value) === String(value))
      return item ? item.label : value || '—'
    },
    toggleExclude(good) {
      const id = Number(good.id)
      this.excludedProductIds = this.excludedProductIds.includes(id)
        ? this.excludedProductIds.filter((item) => item !== id)
        : [...this.excludedProductIds, id]
    },
    toggleGood(id) {
      id = Number(id)
      const exists = this.selected.includes(id)
      this.selected = exists ? this.selected.filter((item) => item !== id) : [...this.selected, id]
      if (exists) this.selectedGoods = this.selectedGoods.filter((item) => Number(item.id) !== id)
      else {
        const good = this.goods.find((item) => Number(item.id) === id)
        if (good && !this.selectedGoods.some((item) => Number(item.id) === id)) this.selectedGoods.push(good)
      }
      if (this.selectorTab === 'selected') {
        const maxPage = Math.max(1, Math.ceil(this.selectedGoods.length / this.selectorPage.limit))
        this.selectorPage = {
          ...this.selectorPage,
          page: Math.min(this.selectorPage.page, maxPage),
          total: this.selectedGoods.length
        }
      }
    },
    addReplace() {
      this.form.replaces.push({ find: '', value: '' })
    },
    removeReplace(index) {
      this.form.replaces.splice(index, 1)
    },
    resetMoreSearch() {
      this.moreSearchChecked = [...this.moreSearchFields]
    }
  }
}
</script>

<style scoped>
.bm-title__repeat-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.bm-title__repeat-row .bm-title__select {
  min-width: 140px;
}

.bm-short-title__search-actions {
  margin-right: auto;
}

@media (max-width: 768px) {
  .bm-title__repeat-row {
    align-items: flex-start;
    flex-direction: column;
  }
}

.bm-title {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  min-height: calc(100vh - 56px);
  overflow-x: hidden;
  background: #f5f6f8;
  color: #1a1a2e;
  font-family: 'Noto Sans SC', sans-serif;
}

.bm-title__preview tr:nth-child(even) {
  background: #fcfcfd;
}

.bm-title__preview tr:hover {
  background: #f0f7ff;
}

.bm-title__preview tr.is-excluded {
  background: #e5e5e5;
  color: #777;
}

.bm-title button,
.bm-title input,
.bm-title select,
.bm-title textarea {
  font: inherit;
}

.bm-title button {
  cursor: pointer;
}

.bm-title__head {
  background: #fff;
  border-bottom: 1px solid #e0e0ec;
  padding: 10px 20px 0;
}

.bm-title__crumb {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #999;
}

.bm-title__crumb button {
  height: 26px;
  padding: 0 10px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  background: #fff;
  color: #666;
}

.bm-title__crumb a {
  margin-left: auto;
  color: #1677ff;
}

.bm-title h1 {
  margin: 12px 0 8px;
  font: 600 18px 'Noto Serif SC', serif;
}

.bm-title__head nav {
  display: flex;
  gap: 22px;
}

.bm-title__head nav button {
  padding: 9px 6px;
  border: 0;
  border-bottom: 2px solid transparent;
  background: #fff;
  color: #666;
  font-size: 13px;
}

.bm-title__head nav button.active {
  border-bottom-color: #c8443c;
  color: #c8443c;
  font-weight: 600;
}

.bm-title__body {
  padding: 14px 20px 82px;
}

.bm-title__filter {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px 14px;
  padding: 14px 16px 10px;
  border: 2px solid #e0e0ec;
  border-radius: 8px;
  background: #fff;
}

.bm-title__field label {
  display: block;
  margin-bottom: 4px;
  color: #666;
  font-size: 10px;
}

.bm-title__field input,
.bm-title__field select,
.bm-title__range input,
.bm-title__method-content input,
.bm-title__method-content select,
.bm-title__method-content textarea,
.bm-title__options select,
.bm-title__select-filter input {
  box-sizing: border-box;
  width: 100%;
  height: 28px;
  padding: 4px 8px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  background: #fff;
  font-size: 11px;
}

.bm-title__range {
  display: flex;
  align-items: center;
  gap: 5px;
}

.bm-title__range span {
  color: #999;
}

.bm-title__filter footer {
  grid-column: 1/-1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  padding-top: 9px;
  border-top: 1px solid #f0f0f0;
  font-size: 12px;
}

.bm-title__filter footer span {
  margin-right: auto;
  color: #999;
}

.bm-title__filter b {
  color: #1677ff;
}

.bm-title__filter button,
.bm-title__picked button,
.bm-title__small-modal footer button,
.bm-title__select-modal footer button {
  height: 28px;
  padding: 0 13px;
  border: 0;
  border-radius: 4px;
  background: #c8443c;
  color: #fff;
  font-size: 12px;
}

.bm-title__filter .plain,
.bm-title__small-modal .plain {
  border: 1px solid #e0e0ec;
  background: #fff;
  color: #666;
}

.bm-title__picked,
.bm-title__fail,
.bm-title__options {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 14px;
  padding: 10px 14px;
  border: 1px solid #e0e0ec;
  border-radius: 6px;
  background: #fff;
  color: #666;
  font-size: 12px;
}

.bm-title__picked button {
  background: #1677ff;
}

.bm-title__picked span {
  color: #1677ff;
}

.bm-title__fail {
  border-color: #ffccd2;
  background: #fff5f5;
  color: #1a1a2e;
}

.bm-title__methods {
  overflow: hidden;
  margin-top: 14px;
  border: 2px solid #e0e0ec;
  border-radius: 8px;
  background: #fff;
}

.bm-title__methods > header {
  padding: 10px 14px;
  border-bottom: 1px solid #e0e0ec;
  background: #f5f0e8;
  font-size: 12px;
  font-weight: 600;
}

.bm-title__methods > header i {
  display: inline-block;
  width: 3px;
  height: 14px;
  margin-right: 7px;
  border-radius: 2px;
  background: #c8443c;
  vertical-align: middle;
}

.bm-short-title__strategy-body {
  padding: 14px;
  font-size: 12px;
}

.bm-short-title__strategy-body > label {
  display: block;
  margin-bottom: 8px;
}

.bm-short-title__from-title-options {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-left: 10px;
}

.bm-title__methods article {
  padding: 12px 14px;
  border-bottom: 1px solid #e0e0ec;
  font-size: 12px;
}

.bm-title__methods article:last-child {
  border-bottom: 0;
}

.bm-title__method-name {
  font-weight: 500;
}

.bm-title__method-content {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin: 10px 0 0 22px;
  color: #666;
}

.bm-title__method-content input {
  width: 190px;
}

.bm-title__method-content input.long {
  width: 360px;
}

.bm-title__method-content textarea {
  width: 360px;
  height: 62px;
  resize: vertical;
}

.bm-title__method-content select {
  width: 145px;
}

.bm-title__method-content small {
  color: #999;
  font-size: 10px;
}

.bm-title__method-content .warning {
  color: #c8443c;
}

.bm-title__replace {
  display: flex;
  align-items: center;
  gap: 8px;
}

.bm-title__replace button {
  height: 28px;
  padding: 0 10px;
  border: 1px solid #91caff;
  border-radius: 4px;
  background: #e6f4ff;
  color: #1677ff;
  font-size: 11px;
}

.bm-title__options {
  background: #f5f0e8;
}

.bm-title__options span {
  margin-left: auto;
}

.bm-title__options select {
  width: 150px;
}

.bm-title__preview {
  overflow: hidden;
  margin-top: 14px;
  border: 2px solid #e0e0ec;
  border-radius: 8px;
  background: #fff;
}

.bm-title__preview header {
  padding: 10px 14px;
  border-bottom: 1px solid #e0e0ec;
  font-size: 12px;
}

.bm-title__preview header b {
  color: #1677ff;
}

.bm-title__preview header button {
  float: right;
  border: 0;
  background: none;
  color: #c8443c;
}

.bm-title__preview table {
  width: 100%;
  border-collapse: collapse;
}

.bm-title__preview th {
  padding: 8px 12px;
  background: #f5f0e8;
  color: #666;
  font-size: 11px;
  font-weight: 500;
  text-align: left;
}

.bm-title__preview td {
  padding: 10px 12px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 11px;
}

.bm-title__head nav .mode-range {
  color: #1677ff;
}

.bm-title__head nav .mode-goods {
  color: #722ed1;
}

.bm-title__head nav .mode-range.active {
  border-bottom-color: #1677ff;
  background: #f0f7ff;
}

.bm-title__head nav .mode-goods.active {
  border-bottom-color: #722ed1;
  background: #f9f0ff;
  color: #722ed1;
}

.bm-title__preview .title-col,
.bm-title__preview .title-cell,
.bm-title__preview .action-cell {
  text-align: center;
  vertical-align: middle;
}

.bm-title__preview td:first-child {
  display: flex;
  align-items: center;
  gap: 8px;
}

.bm-title__preview p {
  margin: 3px 0 0;
}

.bm-title__preview small {
  color: #999;
}

.bm-short-title__meta,
.bm-short-title__text {
  display: block;
  line-height: 1.5;
}

.bm-short-title__meta {
  white-space: nowrap;
}

.bm-short-title__text {
  max-width: 260px;
  overflow: hidden;
  word-break: break-all;
}

.bm-title__preview textarea {
  width: 100%;
  min-height: 38px;
  box-sizing: border-box;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  font-size: 11px;
}

.bm-title__preview .title-cell textarea {
  min-width: 300px;
  padding: 5px;
  line-height: 1;
  background: #fafcff;
  resize: vertical;
}

.bm-title__preview td button {
  height: 24px;
  border: 1px solid #91caff;
  border-radius: 3px;
  background: #e6f4ff;
  color: #1677ff;
  font-size: 10px;
}

.bm-title__field {
  min-width: 0;
}

.bm-title__preview .action-cell {
  min-width: 110px;
  white-space: nowrap;
}

.bm-title__preview .action-cell button {
  min-width: 82px;
  height: 30px;
  padding: 0 12px;
  border-color: #91caff;
  border-radius: 5px;
  background: #e6f4ff;
  color: #1677ff;
  font-size: 12px;
  line-height: 28px;
  transition: 0.2s;
}

.bm-title__preview .action-cell button:hover,
.bm-title__preview .action-cell button:focus {
  border-color: #409eff;
  background: #bae0ff;
  color: #0958d9;
}

.bm-title__preview .action-cell button:active {
  transform: translateY(1px);
}

.bm-title__preview .action-cell button.restore {
  border-color: #ffd591;
  background: #fff7e6;
  color: #d46b08;
}

.bm-title__preview .action-cell button.restore:hover,
.bm-title__preview .action-cell button.restore:focus {
  border-color: #ffa940;
  background: #ffe7ba;
  color: #ad4e00;
}

.bm-title__preview td button:hover {
  background: #bae0ff;
}

.bm-title__preview td button.restore {
  border-color: #ffd591;
  background: #fff7e6;
  color: #d46b08;
}

.bm-title__image {
  display: inline-flex;
  position: relative;
  z-index: 1;
  width: 46px;
  height: 46px;
  align-items: center;
  justify-content: center;
  border: 1px solid #ffccd2;
  border-radius: 4px;
  background: #fff5f5;
  object-fit: cover;
  font-size: 16px;
  cursor: pointer;
}

.bm-title__pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 10px 14px;
  border-top: 1px solid #f0f0f0;
  color: #666;
  font-size: 12px;
}

.bm-title__pagination button {
  padding: 4px 10px;
  border: 1px solid #d9e2f0;
  border-radius: 4px;
  background: #fff;
  color: #1677ff;
}

.bm-title__pagination button:disabled {
  color: #bbb;
  cursor: not-allowed;
}

.bm-title__pagination select {
  height: 26px;
  border: 1px solid #d9e2f0;
  border-radius: 4px;
}

::v-deep(.bm-title__image .el-image__inner) {
  border-radius: 4px;
  cursor: pointer;
}

.bm-title__bottom {
  position: fixed;
  left: var(--merchant-sidebar-width, 210px);
  right: 0;
  z-index: 20;
  bottom: 0;
  display: flex;
  width: auto;
  max-width: none;
  min-width: 0;
  box-sizing: border-box;
  overflow-x: hidden;
  flex-wrap: nowrap;
  align-items: center;
  gap: 10px;
  padding: 10px 20px;
  border-top: 1px solid #e0e0ec;
  background: #fff;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);
  font-size: 12px;
}

.bm-title__bottom button {
  min-width: 0;
  flex: 0 1 auto;
  height: 30px;
  padding: 0 14px;
  border: 0;
  border-radius: 4px;
  color: #fff;
}

.bm-title__bottom .preview {
  background: #1677ff;
}

.bm-title__bottom .start {
  margin-left: auto;
  margin-right: 50px;
  padding: 0 28px;
  background: #52c41a;
}

.bm-title__bottom .time {
  background: #fff;
  color: #666;
  border: 1px solid #e0e0ec;
}

.bm-title__mask {
  position: fixed;
  z-index: 3000;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(3px);
}

.bm-title__select-modal,
.bm-title__small-modal {
  width: min(1180px, 96vw);
  min-width: 900px;
  overflow: hidden;
  border: 1px solid #e0e0ec;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);
}

.bm-title__small-modal {
  width: min(400px, 100%);
  min-width: 0;
}

.bm-title__select-modal > header,
.bm-title__small-modal > header {
  display: flex;
  justify-content: space-between;
  padding: 12px 18px;
  border-bottom: 1px solid #e0e0ec;
  background: #fafafa;
  font-size: 14px;
}

.bm-title__select-modal > header button,
.bm-title__small-modal > header button {
  width: 24px;
  height: 24px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  background: #fff;
  color: #666;
  font-size: 18px;
}

.bm-title__select-modal nav {
  display: flex;
  padding: 0 18px;
  border-bottom: 1px solid #e0e0ec;
}

.bm-title__select-modal nav button {
  padding: 10px 14px;
  border: 0;
  border-bottom: 2px solid transparent;
  background: #fff;
  color: #666;
  font-size: 12px;
}

.bm-title__select-modal nav button.active {
  border-bottom-color: #1677ff;
  color: #1677ff;
}

.bm-title__select-filter {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 10px 18px;
  background: #fafafa;
}

.bm-title__selector-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 18px;
  background: #fafafa;
}

.bm-title__selector-toolbar .bm-title__select-filter {
  flex: 1;
  padding: 0;
  background: transparent;
}

.bm-title__page-size {
  width: 96px;
}

.bm-title__select-all {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  margin-left: auto;
  white-space: nowrap;
  gap: 6px;
  font-size: 12px;
}

.bm-title__select-filter .bm-title__group-select {
  width: 108px;
}

.bm-title__select-filter .bm-title__group-select .el-input,
.bm-title__select-filter .bm-title__group-select .el-input__inner {
  width: 108px;
}

.bm-title__select-filter .bm-title__group-select .el-input,
.bm-title__select-filter .bm-title__group-select .el-input__inner,
.bm-title__selector-pagination .bm-title__page-size .el-input,
.bm-title__selector-pagination .bm-title__page-size .el-input__inner {
  height: 28px;
  line-height: 28px;
}

::v-deep(.el-input__inner),
::v-deep(.el-input__icon) {
  height: 28px;
  line-height: 28px;
}

.bm-title__select-filter input {
  width: 150px;
  height: 28px;
}

.bm-title__selector-pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 0;
  color: #666;
  font-size: 12px;
}

.bm-title__selector-pagination button {
  padding: 3px 8px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  color: #606266;
}

.bm-title__selector-pagination button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.bm-title__select-filter button {
  height: 28px;
  padding: 0 12px;
  border: 0;
  border-radius: 4px;
  background: #1677ff;
  color: #fff;
  font-size: 11px;
}

.bm-title__select-modal main {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 10px;
  max-height: 350px;
  padding: 14px 18px;
  overflow: auto;
}

.bm-title__select-modal main button {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px;
  border: 2px solid #e0e0ec;
  border-radius: 6px;
  background: #fff;
  color: #1a1a2e;
  text-align: left;
  min-height: 150px;
}

.bm-title__select-modal main button.selected {
  border-color: #1677ff;
  background: #e6f4ff;
}

.bm-title__select-modal main b {
  height: 48px;
  background: #fff5f5;
  font-size: 27px;
  text-align: center;
}

.bm-title__select-modal main img {
  width: 100%;
  height: 159px;
  object-fit: contain;
  background: #fff5f5;
}

.bm-title__select-modal main span {
  overflow: hidden;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bm-title__select-modal main small {
  color: #999;
  font-size: 10px;
}

.bm-title__select-modal footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  align-items: center;
  padding: 10px 18px;
  border-top: 1px solid #e0e0ec;
  font-size: 12px;
}

.bm-title__select-modal footer > span {
  margin-right: auto;
}

.bm-title__select-modal footer button {
  background: #1677ff;
}

.bm-title__small-modal main {
  padding: 24px 20px;
  font-size: 13px;
}

.bm-title__small-modal main label {
  display: flex;
  align-items: center;
  gap: 10px;
}

.bm-title__small-modal main input {
  height: 28px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
}

.bm-title__small-modal footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 18px;
  border-top: 1px solid #e0e0ec;
}

.bm-title__small-modal .success-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.bm-title__small-modal .success-message b {
  display: flex;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #f6ffed;
  color: #52c41a;
  font-size: 28px;
}

.bm-title__small-modal .success-message p {
  margin: 12px 0 5px;
}

.bm-title__small-modal .success-message small {
  color: #999;
}

@media (max-width: 960px) {
  .bm-title__filter {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .bm-title__options span {
    margin-left: 0;
  }

  .bm-title__select-modal {
    min-width: 0;
  }

  .bm-title__select-modal main {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .bm-title__selector-toolbar {
    flex-wrap: wrap;
  }
}

@media (max-width: 720px) {
  .bm-title__filter {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .bm-title__select-modal main {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .bm-title__bottom .start {
    margin-left: 0;
  }
}

@media (max-width: 520px) {
  .bm-title__head,
  .bm-title__body {
    padding-right: 12px;
    padding-left: 12px;
  }

  .bm-title__filter {
    grid-template-columns: 1fr;
  }

  .bm-title__method-content input,
  .bm-title__method-content input.long,
  .bm-title__method-content textarea {
    width: 100%;
  }

  .bm-title__select-modal main {
    grid-template-columns: repeat(2, 1fr);
  }

  .bm-title__bottom {
    left: 0;
    gap: 6px;
    padding: 8px 12px;
  }

  .bm-title__bottom .start {
    padding: 0 12px;
  }

  .bm-title__bottom .preview {
    display: none;
  }
}

.bm-title__method-name {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: #1a1a2e;
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
  cursor: pointer;
}

.bm-title__method-name input,
.bm-title__method-content input[type='checkbox'],
.bm-title__method-content input[type='radio'] {
  width: 14px;
  height: 14px;
  min-width: 14px;
  margin: 0;
  padding: 0;
  accent-color: #1677ff;
  cursor: pointer;
}

.bm-title__method-content {
  align-items: center;
  margin-top: 10px;
  padding-left: 22px;
  line-height: 28px;
}

::v-deep(.bm-short-title__length-input) {
  width: 92px;
  margin: 0 6px;
  vertical-align: middle;
}

::v-deep(.bm-short-title__length-input .el-input__inner) {
  height: 28px;
  padding: 0 22px 0 8px;
  border-color: #e0e0ec;
  border-radius: 4px;
  color: #1a1a2e;
  font-size: 12px;
  line-height: 28px;
  text-align: center;
}

::v-deep(.bm-short-title__length-input .el-input-number__decrease),
::v-deep(.bm-short-title__length-input .el-input-number__increase) {
  width: 18px;
  height: 13px;
  color: #999;
  font-size: 10px;
  line-height: 13px;
}
::v-deep(.el-input-number) {
  line-height: 0px !important;
}

::v-deep(.bm-short-title__length-input.is-controls-right .el-input-number__increase) {
  top: 1px;
  right: 1px;
  bottom: auto;
  left: auto;
}

::v-deep(.bm-short-title__length-input.is-controls-right .el-input-number__decrease) {
  top: auto;
  right: 1px;
  bottom: 1px;
  left: auto;
}

::v-deep(.bm-short-title__length-input .el-input-number__decrease [class*='el-icon']),
::v-deep(.bm-short-title__length-input .el-input-number__increase [class*='el-icon']) {
  font-size: 10px;
  line-height: 13px;
  transform: scale(0.65);
}

.bm-title__method-content > label {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
  cursor: pointer;
}

.bm-title__method-content > span {
  flex-shrink: 0;
  color: #666;
  font-size: 12px;
}

.bm-title__method-content .bm-title__count-input,
.bm-title__method-content .bm-title__count-textarea {
  position: relative;
  line-height: normal;
}

.bm-title__method-content .bm-title__count-input input {
  width: 360px;
}

.bm-title__method-content .bm-title__count-input small,
.bm-title__method-content .bm-title__count-textarea small {
  position: absolute;
  right: 8px;
  bottom: 5px;
  color: #999;
  font: 10px 'JetBrains Mono', monospace;
}

.bm-title__method-content .bm-title__count-textarea textarea {
  width: 360px;
  padding-bottom: 18px;
}

.bm-title__method-content .bm-title__replace {
  width: 100%;
  gap: 8px;
}

.bm-title__method-content .bm-title__replace input {
  width: 160px;
}

.bm-title__replace .danger {
  border-color: #ffccd2;
  background: #fff5f5;
  color: #c8443c;
}

.bm-title__method-content .bm-title__inline {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.bm-title__method-content .bm-title__inline input:not([type='checkbox']):not([type='radio']) {
  width: 200px;
}

.bm-title__method-content select:disabled {
  background: #f5f5f5;
  color: #999;
}

.bm-title__method-content > .warning {
  display: block;
  width: 100%;
  line-height: 16px;
}

.bm-title__methods article {
  padding: 14px 14px 13px;
}

::v-deep(.bm-title__methods .el-checkbox__inner) {
  width: 14px;
  height: 14px;
  border-color: #d9c98d;
  border-radius: 3px;
}

::v-deep(.bm-title__methods .el-checkbox__inner:hover),
::v-deep(.bm-title__methods .el-checkbox__input.is-focus .el-checkbox__inner) {
  border-color: #d4a946;
}

::v-deep(.bm-title__methods .el-checkbox__input.is-checked .el-checkbox__inner),
::v-deep(.bm-title__methods .el-checkbox__input.is-indeterminate .el-checkbox__inner) {
  border-color: #d4a946;
  background: #d4a946;
}

::v-deep(.bm-title__methods .el-checkbox__label) {
  color: #1a1a2e;
  font-size: 12px;
}

::v-deep(.bm-title__methods .el-checkbox__input.is-checked + .el-checkbox__label) {
  color: #1a1a2e;
}

.bm-title__select {
  width: 160px;
  line-height: normal;
}

.bm-title__filter-select {
  display: block;
  width: 100%;
}

.bm-title__date-range {
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
  gap: 5px;
}

.bm-title__date-input {
  flex: 1 1 0;
  min-width: 0;
  box-sizing: border-box;
  width: 0;
  height: 28px;
  padding: 4px 8px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  background: #fff;
  color: #666;
  font-size: 11px;
}

.bm-title__date-separator {
  flex: 0 0 12px;
  color: #999;
  text-align: center;
}

.bm-title__store-select {
  width: 120px;
}

.bm-title__stores,
.bm-title__filter footer > div {
  display: flex;
  align-items: center;
  gap: 8px;
}

.bm-title__filter .add-store {
  background: #722ed1;
}

.bm-title__filter .add-store:hover {
  background: #531dab;
}

::v-deep(.bm-title__select .el-input__inner),
::v-deep(.bm-title__filter-select .el-input__inner),
::v-deep(.bm-title__store-select .el-input__inner) {
  height: 28px;
  padding: 0 28px 0 8px;
  border-color: #e0e0ec;
  border-radius: 4px;
  color: #1a1a2e;
  font-size: 12px;
  line-height: 28px;
  text-align: left;
}

::v-deep(.bm-title__select .el-input__suffix),
::v-deep(.bm-title__filter-select .el-input__suffix),
::v-deep(.bm-title__store-select .el-input__suffix) {
  right: 7px;
}

::v-deep(.bm-title__select .el-input__icon),
::v-deep(.bm-title__filter-select .el-input__icon),
::v-deep(.bm-title__store-select .el-input__icon) {
  color: #999;
  font-size: 14px;
  line-height: 28px;
}

::v-deep(.bm-title__select .el-input__inner:focus),
::v-deep(.bm-title__filter-select .el-input__inner:focus),
::v-deep(.bm-title__store-select .el-input__inner:focus) {
  border-color: #d4a946;
}

.bm-title__filter .more-search {
  padding: 0 2px;
  background: transparent;
  color: #1677ff;
}

.bm-title__more-modal {
  width: min(540px, 100%);
  overflow: hidden;
  border: 1px solid #e0e0ec;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);
}

.bm-title__more-modal > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 18px;
  border-bottom: 1px solid #e0e0ec;
  background: #fafafa;
  font-size: 14px;
}

.bm-title__more-modal > header button {
  width: 24px;
  height: 24px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  background: #fff;
  color: #666;
  font-size: 18px;
}

.bm-title__more-modal main {
  padding: 16px 18px;
}

.bm-title__more-modal .el-checkbox-group {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.bm-title__more-modal footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 18px;
  border-top: 1px solid #e0e0ec;
}

.bm-title__more-modal footer button {
  height: 28px;
  padding: 0 13px;
  border: 0;
  border-radius: 4px;
  background: #1677ff;
  color: #fff;
  font-size: 12px;
}

.bm-title__more-modal footer .plain {
  border: 1px solid #e0e0ec;
  background: #fff;
  color: #666;
}

::v-deep(.bm-title__more-modal .el-checkbox__inner) {
  width: 14px;
  height: 14px;
  border-color: #d9c98d;
  border-radius: 3px;
}

::v-deep(.bm-title__more-modal .el-checkbox__input.is-checked .el-checkbox__inner) {
  border-color: #d4a946;
  background: #d4a946;
}

::v-deep(.bm-title__more-modal .el-checkbox__label) {
  color: #1a1a2e;
  font-size: 12px;
}

.bm-title__filter > footer {
  justify-content: space-between;
}
</style>

<style>
.el-popper.bm-title__select-popper {
  z-index: 4000 !important;
}
</style>
